import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import styles from './DayWiseAgsn.module.css';
import PropTypes from 'prop-types';
import { API } from '../../apis/api';
import { buildErrorMessage } from '../../apis/calls';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import {
  Table,
  BackButton,
  CommentFormModal,
  BulkOptionsToolbar,
  DropToolBar,
  LineTransferModal,
  DayWiseFinishedGoodsLineTransferDisplay,
  ReprintWarningDialog
} from '../../components';
import Select from 'react-select';
import {
  statusStringMap,
  aggregateReasons,
  aggregateAgencies,
} from '../../staticData';
import {
  AGGREGATE_STATUS,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  DATE_FORMAT,
  cabLinesForAllPlants,
  JLR_PLANT,
  AGGREGATES,
  ZPL_AGSN_BIW_TEMPLATE,
  PANTNAGAR_PLANT_NAME,
} from '../../constants';
import { withAllowedOperationsProvider } from '../../hocs';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import AgsnSwapModal from '../../components/AgsnSwapModal/AgsnSwapModal';
import { downloadCsv, checkForPendingAgsnsOrAsn, getAggregateAuthOperation } from '../../utils/utils';
import CarryForwardModal from '../../components/CarryForwardModal/CarryForwardModal';
import AltMatWarningDailog from '../../components/AltMatWarningDailog/AltMatWarningDailog';

const DayWiseAgsn = ({
  aggregate,
  setAgsnCount,
  hasActiveEdits,
  setHasActiveEdits,
  rowsData,
  loadAgsnsForADate,
  lastRefreshedDate,
  selectedDate,
  setSelectedDate,
  setHasDayWiseAciveEdit,
  loadLinedOutAgsnOfSelectedPlantAndLineForDate,
  hasPendingBacklogAsns,
  agsnDates,
}) => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;
  const [plantOptions] = usePlantAndLinesStore().plantOptions;
  const [aggregateLine] = usePlantAndLinesStore().aggregateLineState;
  const {
    showInternalError,
    showError,
    showSuccess,
    showPopup,
    showInformation,
    showLoading,
    closePopUp,
  } = usePopupManager();
  const history = useHistory();
  const ROW_HEIGHT = 38;
  const [isPullbackModalOpen, setIsPullbackModalOpen] = useState(false);
  const [alternatePart, setAlternatePart] = useState([]);
  const [alternatePartList, setAlternatePartList] = useState([]);
  const alternatePartUseRef = useRef([]);
  const [selectedAsns, setSelectedAsns] = useState([]);
  const [selectedAgsnsForSwap, setSelectedAgsnsForSwap] = useState([]);
  const [isAssignShiftFormOpen, setIsAssignShiftFormOpen] = useState(false);
  const [isPrintingEnabled, setIsPrintingEnabled] = useState(true);
  const [isReprintConfirmationOpen, setIsReprintConfirmationOpen] = useState(
    false
  );
  const [asnsToReprint, setAsnsToReprint] = useState([]);
  const [enableRDFButton, setEnableRDFButton] = useState(true);

  const closeAssignShiftForm = () => setIsAssignShiftFormOpen(false);

  const RESOURCE_OPERATION = getAggregateAuthOperation(USER_OPERATIONS.AGGREGATE_LINE_OUT, plant);
  const [isLineOutModalOpen, setIsLineOutModalOpen] = useState(false);
  const [isAgsnSwapModalOpen, setIsAgsnSwapModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [agsnSwapCount, setAgsnSwapCount] = useState([]);
  const closeModal = () => setIsLineOutModalOpen(false);
  const [isButtonEnable, setIsButtonEnable] = useState(true);
  const [shiftAvailability, setShiftAvailability] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [shopId, setShopId] = useState(null);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [selectedRowsReadyForDrop, setSelectedRowsReadyForDrop] = useState([]);
  const chkControlToDisplay = useRef(enableRDFButton);
  const [isLineTransferModalOpen, setIsLineTransferModalOpen] = useState(false);
  const [transferLines, setTransferLines] = useState([]);
  const closeLineTransferModal = () => setIsLineTransferModalOpen(false);
  const [
    isLineTransferAsnDisplayOpen,
    setIsLineTransferAsnDisplayOpen,
  ] = useState(false);
  const [lineSelectedForTransfer, setLineSelectedForTransfer] = useState(null);
  const closeLinetransferAnsDisplay = () =>
    setIsLineTransferAsnDisplayOpen(false);

  const isLucknowProlifePlant = plant?.label === 'Lucknow-Prolife'
  const parentName = isLucknowProlifePlant ? 'Parent' : 'VC'

  if (enableRDFButton) chkControlToDisplay.current = enableRDFButton;

  let alternatePartResponse = [];

  const openLineTransferModal = async (selectedRows) => {
    try {
      showLoading()
      setIsLineTransferModalOpen(true);
      setSelectedRows(selectedRows);
      // Fetch the lines for Aggergates for Agsn transferre
      const response = await API.get(
        API_RESOURCE_URLS.getLinesForTransfer(plant.value, aggregateLine.value),
      );
      const lineDetails = response.data;
      setTransferLines(lineDetails);
      closePopUp();
    } catch (error) {
      console.error(buildErrorMessage(error));
      showError({
        contextText: `Failed to Fetch Lines for Agsn Transfer`,
        error: error,
      });
      setTransferLines([]);
    }
  };

  const fetchLastAgsnGeneratedDate = async (plant, line) => {
    try {
      const response = await API.get(
        API_RESOURCE_URLS.lastAgSNGeneratedDate(plant, line)
      );
      return response.data.date;
    } catch (error) {
      console.error(buildErrorMessage(error));
      showError({
        contextText: `Failed to Fetch Last Agsn Generated Date`,
        error: error,
      });
      return null;
    }
  };

  const handleLineSelectionForLineTransfer = async (selectedLineName) => {
    if (!selectedDate) {
      showError({
        contextText: 'Agsn is not Generated for this line.',
        info: 'Please generate Agsn before proceeding.',
      });
      return;
    }
    const selectedLine = transferLines.find(
      (line) => line.lineName === selectedLineName
    );
    if (!selectedLine) {
      showError({ contextText: 'Selected line not found.' });
      return;
    }
    const lastAgsnDate = await fetchLastAgsnGeneratedDate(plant.value, selectedLine.line);
    if (lastAgsnDate && moment(lastAgsnDate).isBefore(selectedDate, 'day')) {
      showError({
        contextText: DISPLAY_MESSAGES.LINE_TRANSFER_ERROR,
        info: `Sequence for ${selectedLineName} is not generated for ${selectedDate.format('DD-MM-YYYY')} .`,
      });
      setIsLineTransferModalOpen(false);
      return;
    }
    setLineSelectedForTransfer(selectedLine);
    setIsLineTransferAsnDisplayOpen(true);
  };

  const executeReprint = (rows) => {
    const labels = rows.map((row) => {
      const {
        agsn,
        materialNumber,
        materialDescription,
        productionDate,
      } = row;

      if (
        aggregate === AGGREGATES.BIW &&
        plant.label === PANTNAGAR_PLANT_NAME
      ) {
        return ZPL_AGSN_BIW_TEMPLATE.replaceAll("{materialNumber}", materialNumber || "")
          .replaceAll("{agsnNumber}", agsn || "")
          .replaceAll("{materialDescription}", materialDescription || "")
          .replaceAll("{date}", productionDate || "");
      }
      return "";
    });
    const zplstring = encodeURIComponent(labels.join("\n"));

    window.location.href = `nirmaan://?cmd=print&zplstring=${zplstring}`;
  };

  const reprintRows = (rows) => {
    if (isPrintingEnabled) {
      const hasDroppedAsn = rows.some(
        (row) => row.status === AGGREGATE_STATUS.DROPPED
      );
      if (hasDroppedAsn) {
        setAsnsToReprint(rows);
        setIsReprintConfirmationOpen(true);
      } else {
        executeReprint(rows);
      }
    }
  };

  const handleConfirmReprint = () => {
    setIsReprintConfirmationOpen(false);
    executeReprint(asnsToReprint);
  };

  const handleCancelReprint = () => {
    setIsReprintConfirmationOpen(false);
    setAsnsToReprint([]);
  };

  const alternatePartAPICall = async (partNumberList) => {
    if (partNumberList.data.length > 0) {
      const alternateMaterialPayload = {
        materialNumbers: Array.from(
          new Set(partNumberList?.data?.map(row => row.materialNumber)),
        ),
      };
      try {
        alternatePartResponse = await API.post(
          API_RESOURCE_URLS.getAlternatePart(plant.value),
          alternateMaterialPayload,
        );
        setAlternatePartList(alternatePartResponse);
        return alternatePartResponse;
      } catch (err) {
        console.error(buildErrorMessage(err));
      }
    }
  };
  alternatePartUseRef.current = alternatePartList;
  const returnAltMatPartList = (arrayOfAltPart, materialNumber) =>
    alternatePartUseRef.current.data?.map(alternateParts => {
      if (alternateParts.materialNumber === materialNumber) {
        alternateParts.alternateMaterialNumbers.map(alternateMaterialList => {
          const alternatePart = {
            value: alternateMaterialList.toString(),
            label: alternateMaterialList.toString(),
          };
          arrayOfAltPart.push(alternatePart);
        });
      }
    });

  const chkAltMatPart = (materialNumber, agsn) => {
    const altMatApiResponse = [
      {
        materialNumber: materialNumber,
        alternateMaterialNumbers: [],
      },
    ];
    const arrayOfAltPart = [
      {
        label: altMatApiResponse[0].materialNumber,
        value: altMatApiResponse[0].materialNumber,
      },
    ];

    if (alternatePartUseRef.current.data?.length > 0) {
      returnAltMatPartList(arrayOfAltPart, materialNumber);
    }
    return arrayOfAltPart;
  };

  const sendAlternateMaterial = (rowsData, selectedPart) => {
    setAlternatePart(prev => [
      ...prev,
      {
        id: rowsData.id,
        materialNumber: selectedPart,
      },
    ]);
  };

  const baseDefaultColumns = [
    {
      width: 150,
      title: 'AgSN',
      field: 'agsn',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      title: 'ASN',
      field: 'parentAsn',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      title: 'Destination',
      field: 'destination',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 190,
      title: 'Part Number',
      field: 'materialNumber',
      enableSearch: true,
      enableFilter: true,
      render: rowsData => {
        return rowsData.status === AGGREGATE_STATUS.ASN_GENERATED &&
          chkAltMatPart(rowsData.materialNumber, '').length > 1 &&
          chkControlToDisplay.current ? (
          <Select
            defaultValue={
              chkAltMatPart(rowsData.materialNumber, rowsData.agsn)[0]
            }
            options={chkAltMatPart(rowsData.materialNumber, rowsData.agsn)}
            onChange={selectedAlternatePart =>
              sendAlternateMaterial(rowsData, selectedAlternatePart.label)
            }
            maxMenuHeight="160px"
            menuPortalTarget={document.body}
            menuPosition={'fixed'}
            menuWidth="100%"
            styles={{
              menuList: provided => ({
                ...provided,
                fontSize: '.7rem',
                '&::-webkit-scrollbar': {
                  width: '4px !important',
                  height: '6px',
                  display: 'block !important',
                  background: 'none',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#f17c7c',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#da6363',
                },
              }),
              control: (baseStyles, state) => ({
                ...baseStyles,
                width: '12em',
                height: '2.57em',
                minHeight: '2.57em',
                alignItems: 'start',
                marginTop: '5px',
              }),
              singleValue: provided => ({
                ...provided,
                fontSize: '.7rem',
              }),
              option: (provided, state) => ({
                ...provided,
                padding: '7px 12px',
              }),
            }}
          />
        ) : (
          <span>{chkAltMatPart(rowsData.materialNumber, '')[0].value}</span>
        );
      },
    },
    {
      width: 235,
      title: 'Part Description',
      field: 'materialDescription',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: 'Shift',
      field: 'aggregateShift',
      enableSearch: true,
      enableFilter: true,
      render: ({ aggregateShift }) => (
        <div style={{ textAlign: 'center' }}>
          {aggregateShift && (
            <div className={styles.shift}>{aggregateShift}</div>
          )}
        </div>
      ),
    },
    ...(aggregate === AGGREGATES.CAB ||
      aggregate === AGGREGATES.BIW ||
      aggregate === AGGREGATES.PAINT
      ? [
        {
          width: 180,
          title: 'Colour',
          field: 'colour',
          enableSearch: true,
          enableFilter: true,
        },
        {
          width: 180,
          title: 'Flashing Flag',
          field: 'flashingFlag',
          enableSearch: true,
          enableFilter: true,
        }
      ]
      : []),
    {
      width: 200,
      title: 'Aggregate Status',
      field: 'aggregateStatus',
      render: row => {
        if (row.status === AGGREGATE_STATUS.ASN_GENERATED)
          return (
            <span style={{ opacity: 0.5 }}>
              {statusStringMap[AGGREGATE_STATUS.ASN_GENERATED]}
            </span>
          );
        if (row.edited) return statusStringMap[AGGREGATE_STATUS.ASN_GENERATED];
        return statusStringMap[row.status];
      },
      enableSearch: true,
      enableFilter: true,
    },
  ].filter(c => c);
  const optionalColumns = [
    {
      width: 170,
      title: `${parentName} Number`,
      field: 'parentMaterialNumber',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: 'Vc Alias',
      field: 'rootMaterialAlias',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 170,
      title: 'VC Material',
      field: 'rootMaterial',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 300,
      title: 'VC Material Description',
      field: 'rootMaterialDescription',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 235,
      title: `${parentName} Description`,
      field: 'parentMaterialDescription',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 170,
      title: 'Production Date',
      field: 'productionDate',
      enableSearch: true,
      enableFilter: true,
    },
    aggregate === AGGREGATES.CAB || aggregate === AGGREGATES.BIW || aggregate === AGGREGATES.PAINT
      ? {
        width: 180,
        title: 'country',
        field: 'country',
        enableSearch: true,
        enableFilter: true,
      }
      : null,
  ].filter(c => c);
  const openModal = selectedRows => {
    setIsLineOutModalOpen(true);
    setSelectedRows(selectedRows);
  };
  const openAgsnSwapModal = selectedRows => {
    setSelectedAgsnsForSwap(selectedRows);
    setIsAgsnSwapModalOpen(true);
  };
  const closePullBackModal = () => setIsPullbackModalOpen(false);
  const openPullBackModal = selectedRows => {
    setIsPullbackModalOpen(true);
    setSelectedRows(selectedRows);
  };
  const redirectToApplicationLandingPage = () => {
    history.push('/');
  };

  const setCount = count => {
    setAgsnCount(count);
  };

  const openAssignShiftForm = selectedRows => {
    setIsAssignShiftFormOpen(true);
    setSelectedAsns(selectedRows);
  };

  const getAgsnsPayloadWithShiftsAssigned = (
    selectedAgsns,
    selectedShiftValue,
  ) => {
    return selectedAgsns.map(agsn => ({
      materialId: agsn.id,
      shiftId: selectedShiftValue,
    }));
  };

  const assignShift = async (agsns, selectedShiftValue) => {
    showLoading();
    const agsnPayload = getAgsnsPayloadWithShiftsAssigned(
      agsns,
      selectedShiftValue,
    );

    await API.patch(
      API_RESOURCE_URLS.assignShiftToMaterial(plant.value, aggregateLine.value),
      agsnPayload,
    );
    closePopUp();
  };

  const getAsnsPayloadWithBulkShiftsAssigned = (
    sortedRequiredShifts,
    requiredAvailableAgsns,
    assignmentsToShiftLabelsMap,
  ) => {
    const payloadWithShiftsAssigned = [];

    const requiredAvailableAgsnsPayload = requiredAvailableAgsns.map(
      ({ id }) => ({ materialId: id }),
    );

    for (const shift of sortedRequiredShifts) {
      const agsnsWithCurrentShiftAssigned = requiredAvailableAgsnsPayload
        .slice(
          payloadWithShiftsAssigned.length,
          payloadWithShiftsAssigned.length +
          assignmentsToShiftLabelsMap[shift.label],
        )
        .map(data => ({ ...data, shiftId: shift.value }));
      payloadWithShiftsAssigned.push(...agsnsWithCurrentShiftAssigned);
    }
    return payloadWithShiftsAssigned;
  };

  const bulkAssignShift = async (
    sortedRequiredShifts,
    requiredAvailableAgsns,
    assignmentsToShiftLabelsMap,
  ) => {
    showLoading();
    const agsnsPayload = getAsnsPayloadWithBulkShiftsAssigned(
      sortedRequiredShifts,
      requiredAvailableAgsns,
      assignmentsToShiftLabelsMap,
    );

    await API.patch(
      API_RESOURCE_URLS.assignShiftToMaterial(plant.value, aggregateLine.value),
      agsnsPayload,
    );
    closePopUp();
  };

  const checkForPendingAgsns = selectedRows => {
    const allPlannedAgsns = rowsData.data.filter(
      agsn => agsn.status === AGGREGATE_STATUS.ASN_GENERATED,
    );
    if (allPlannedAgsns.length && selectedRows.length) {
      const valid = selectedRows.every(
        (selectedRow, index) => selectedRow.id === allPlannedAgsns[index].id,
      );
      return valid;
    }
    return false;
  };
  const isShiftAssigned = rows => {
    const notAssigned = rows
      .filter(row => row.shiftName === null)
      .map(row => row.agsn);
    return notAssigned;
  };
  const checkAltMatPartForInformation = selectedRows => {
    let valid = true;
    selectedRows.map(checkAltMatSelectedRow => {
      if (chkAltMatPart(checkAltMatSelectedRow.materialNumber, '').length > 1)
        return valid;
      else return (valid = false);
    });
    return valid;
  };

  const getNonPendingAgSNs = rows =>
    rows
      .filter(row => row.status !== AGGREGATE_STATUS.ASN_GENERATED)
      .map(row => row.agsn);

  const readyfordropRows = async rows => {
    setSelectedRowsReadyForDrop(rows);
    const asns = rowsData.data;
    const errors = checkForInvalidSequence(asns);
    const altMatInfoPopup = checkAltMatPartForInformation(rows);
    if (errors.length)
      return showError({
        info: errors,
        contextText: DISPLAY_MESSAGES.CLEAR_ERRORS,
      });

    if (hasPendingBacklogAsns)
      return showError({
        contextText: `Please clear all the pending AgSNs from previous tab`,
      });

    const nonPendingAgSNs = getNonPendingAgSNs(rows);
    if (nonPendingAgSNs.length)
      return showError({
        info: nonPendingAgSNs,
        contextText: `Looks like you have selected AgSNs which are not in pending state. Please unselect the following AgSNs and try again`,
      });

    if (!checkForPendingAgsns(rows))
      return showError({
        contextText: `Please select the AgSNs in sequence for you to mark ready for drop`,
      });

    const noShiftAssignedRows = isShiftAssigned(rows);
    if (noShiftAssignedRows.length)
      return showError({
        info: noShiftAssignedRows,
        contextText: `Please assign a Shift for the below AgSNs, before doing Ready for Drop.`,
      });

    if (altMatInfoPopup) {
      setIsWarningOpen(altMatInfoPopup);
      return;
    }
    if (!isWarningOpen) {
      callOnAltMatConfirmation(rows);
    }
  };

  const searchAlternatePart = (id, selectedAlternatePartList) => {
    for (
      let alternatePartIndex = 0;
      alternatePartIndex < selectedAlternatePartList.length;
      alternatePartIndex++
    ) {
      if (selectedAlternatePartList[alternatePartIndex].id === id) {
        return selectedAlternatePartList[alternatePartIndex];
      }
    }
  };

  const callOnAltMatConfirmation = async rows => {
    try {
      showLoading();

      const payload = rows.map(row => {
        const foundAltPart = searchAlternatePart(row.id, alternatePart);
        if (foundAltPart) {
          return foundAltPart;
        } else {
          return { id: row.id, materialNumber: row.materialNumber };
        }
      });

      await API.patch(
        API_RESOURCE_URLS.agsnReadyForDrop(plant.value, aggregateLine.value),
        { updates: payload },
      );
      if (
        isPrintingEnabled &&
        plant.label === PANTNAGAR_PLANT_NAME &&
        aggregate === AGGREGATES.BIW
      ) {
        executeReprint(rows);
      }
      loadAgsnsForADate(plant?.value, aggregateLine?.value, selectedDate);
      closePopUp();
      setAlternatePart([]);
      showSuccess({
        contextText: DISPLAY_MESSAGES.AGSN_STATUS_UPDATED,
        info: '',
      });
    } catch (err) {
      console.error(buildErrorMessage(err));
      const errorMessage = err?.request?.responseText  || showInternalError({ error: err })
      showError({
        contextText: errorMessage,
        info: '',
        error: buildErrorMessage(err),
      });
    }
  };

  const checkForInvalidSequence = agsns => {
    const errors = [];
    const indexOfFirstPlannedAgsn = agsns.findIndex(
      agsn => agsn.status === AGGREGATE_STATUS.ASN_GENERATED,
    );
    if (indexOfFirstPlannedAgsn >= 0) {
      const firstDroppedAgnsIndexAfterPlannedAgsn = agsns
        .slice(indexOfFirstPlannedAgsn + 1)
        .findIndex(agsn => agsn.status === AGGREGATE_STATUS.READY_FOR_DROP);
      if (firstDroppedAgnsIndexAfterPlannedAgsn >= 0)
        errors.push(DISPLAY_MESSAGES.DROP_SEQUENCE_VIOLATION_WARNING);
    }

    const unCommentedLineOuts = agsns
      .filter(agsn => agsn.status === AGGREGATE_STATUS.LINE_OUT && agsn.edited)
      .filter(agsn => !agsn.reason || !agsn.agency);

    if (unCommentedLineOuts.length > 0)
      errors.push(
        'Reason and Agency details are required when lining-out an AgSN.',
      );
    return errors;
  };
  const lineoutRows = async (rows, reason, agency, comment) => {
    const agsns = rowsData.data;
    const errors = checkForInvalidSequence(agsns);
    if (errors.length)
      return showError({
        info: errors,
        contextText: DISPLAY_MESSAGES.CLEAR_ERRORS,
      });

    const editedrows = rows.map(row => ({
      ...row,
      reason,
      agency,
      comment,
    }));
    try {
      setIsButtonEnable(false);
      showLoading();
      const payload = editedrows.map(({ agsnId, reason, agency, comment }) => ({
        asnId: agsnId,
        reason,
        agency,
        comment,
      }));
      const response = await API.patch(API_RESOURCE_URLS.AGSN_LINE_OUT(aggregateLine.value),
        {
          updates: payload,
        }
      );
      loadLinedOutAgsnOfSelectedPlantAndLineForDate();
      loadAgsnsForADate(plant?.value, aggregateLine?.value, selectedDate); //reload data
      setIsButtonEnable(true);
      closePopUp();
      if (response.status === 200) {
        showSuccess({
          contextText: DISPLAY_MESSAGES.AGSN_STATUS_LINEOUT,
          info: '',
        });
      } else if (response.status === 202 && response.data?.length) {
          showInformation({
            contextText: response.data[0],
            info: '',
          });
        }
    } catch (err) {
      console.error(buildErrorMessage(err));
      showInternalError({ error: err });
    }
  };

  const pullBackAgsn = async (selectedRows, reason, agency, comment) => {
    try {
      setIsButtonEnable(false);
      showLoading();
      const idsOfSelectedRows = selectedRows.map(res => {
        return res.agsnId;
      });
      const payload = {
        asnIds: idsOfSelectedRows,
        reason,
        agency,
        comment,
      };
      await API.patch(
        API_RESOURCE_URLS.agsnPullback(plant.value, aggregateLine.value),
        payload,
      );
      setIsPullbackModalOpen(false);
      loadLinedOutAgsnOfSelectedPlantAndLineForDate();
      loadAgsnsForADate(plant?.value, aggregateLine?.value, selectedDate); //reload data
      setIsButtonEnable(true);
      closePopUp();
      showSuccess({
        contextText: DISPLAY_MESSAGES.AGSN_STATUS_PULLBACK_SUCCESS,
        info: '',
      });
    } catch (err) {
      console.error(buildErrorMessage(err));
      showPopup({
        error: err,
        contextText: DISPLAY_MESSAGES.AGSN_STATUS_PULLBACK_FAILED,
      });
    }
  };
  const reloadData = () =>
    loadAgsnsForADate(plant?.value, aggregateLine?.value, selectedDate);

  const fetchShiftAssignmentsFor = async (
    plantId,
    shopId,
    lineId,
    from,
    to,
  ) => {
    if (!plantId && !shopId && !lineId && !from && !to) return;
    const response = await API.get(
      API_RESOURCE_URLS.shiftAssignments(plantId, shopId, lineId, from, to),
    );
    return response.data;
  };

  const loadAvailableShiftAssignmentsFor = async (
    plantId,
    shopId,
    lineId,
    forDate,
  ) => {
    setIsLoading(true);
    let shiftsForDate = forDate?.format(DATE_FORMAT.ISO);
    if (forDate?.isBefore(moment().format(DATE_FORMAT.ISO))) {
      shiftsForDate = moment().format(DATE_FORMAT.ISO);
    }
    try {
      const activeShifts = await fetchShiftAssignmentsFor(
        plantId,
        shopId,
        lineId,
        shiftsForDate,
        shiftsForDate,
      );

      const shiftAvailabilityData = activeShifts.map(shift => {
        return {
          label: shift.shiftName,
          value: shift.shiftId,
        };
      });
      const sortedShiftAvailabilityData = shiftAvailabilityData.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      await setShiftAvailability(sortedShiftAvailabilityData);
      setIsLoading(false);
    } catch (error) {
      console.error(buildErrorMessage(error));
      showInternalError({ error: error });
      setShiftAvailability([]);
    }
  };

  const loadShopIdForSelectedLine = async lineId => {
    try {
      const response = await API.get(
        API_RESOURCE_URLS.lineDetailsByLineId(lineId), // TODO: get from planning instead of digital twin service
      );
      const lineDetails = response?.data;
      setShopId(lineDetails.shop?.id);
    } catch (error) {
      console.error(buildErrorMessage(error));
      showInternalError({ error: error });
      setShopId(null);
    }
  };

  useEffect(() => {
    alternatePartAPICall(rowsData); // Call the function
       // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ rowsData]);

  useEffect(() => {
    if (aggregateLine.value) {
      loadShopIdForSelectedLine(aggregateLine.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aggregateLine]);

  useEffect(() => {
    if (rowsData.loading) {
      showLoading();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isButtonEnable]);

  useEffect(() => {
    if (
      aggregateLine.value &&
      selectedDate &&
      shopId &&
      plant.value &&
      isAssignShiftFormOpen
    ) {
      loadAvailableShiftAssignmentsFor(
        plant.value,
        shopId,
        aggregateLine.value,
        selectedDate,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plant, shopId, aggregateLine, selectedDate, isAssignShiftFormOpen]);

  useEffect(() => {
    if (selectedDate) {
      selectedDate.isBefore(moment(), 'day') === true
        ? setEnableRDFButton(!selectedDate.isBefore(moment(), 'day'))
        : setEnableRDFButton(!selectedDate.isAfter(moment(), 'day'));
    }
  }, [selectedDate]);

  useEffect(() => {
    setHasDayWiseAciveEdit(hasActiveEdits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasActiveEdits]);

  const prepareJsonHeaderAndValueFormats = aggregatePartNames => {
    const vcAggregateHeaderAndValueFormats = aggregatePartNames.map(
      partName => ({
        label: partName + ' Status',
        value: row =>
          row.materialGroupClusters.filter(group => group.name === partName)[0]
            ?.materials[0]?.aggregateStatus || 'unavailable',
      }),
    );

    const vcHeaderAndValueFormats = [
      {
        label: 'AGSN',
        value: row => row.agsn,
      },
      {
        label: 'ASN',
        value: row => row.parentAsn,
      },
      {
        label: 'Destination',
        value: row => row.destination,
      },
      {
        label: 'Part Number',
        value: row => '="' + row.materialNumber + '"',
      },
      {
        label: 'VC Alias',
        value: row => row.rootMaterialAlias || '',
      },
      {
        label: 'Part Description',
        value: row => row.materialDescription,
      },
      {
        label: 'Shift',
        value: row => row.aggregateShift,
      },
      {
        label: 'Colour',
        value: row => row.colour,
      },
      {
        label: 'Aggregate Status',
        value: row => row.aggregateStatus,
      },

      {
        label: `${parentName} Number`,
        value: row => row.parentMaterialNumber,
      },
      {
        label: `${parentName} Description`,
        value: row => row.parentMaterialDescription?.replace(/[\n\r,]/g, ''),
      },
      {
        label: 'Production Date',
        value: row => row.productionDate,
      },
    ].filter(c => c);

    return [...vcHeaderAndValueFormats, ...vcAggregateHeaderAndValueFormats];
  };

  const generateAndDownloadLineoutCsvReport = filteredData => {
    try {
      if (!rowsData.loading) {
        const dateValue = selectedDate.isBefore(
          moment().format(DATE_FORMAT.ISO),
        )
          ? 'AllDates'
          : selectedDate.format('YYYYMMDD');
        const jsonData = filteredData;
        const aggregatePartNames =
          rowsData.data[0]?.materialGroupClusters.map(group => group.name) ||
          [];

        const { parseAsync } = require('json2csv');
        const fields = prepareJsonHeaderAndValueFormats(aggregatePartNames);
        const opts = { fields };
        parseAsync(jsonData, opts)
          .then(csv => {
            const exportedFilename =
              'AgsnReport_' +
              plant.label +
              '_' +
              aggregateLine.label +
              '_' +
              dateValue +
              '.csv';
            downloadCsv(csv, exportedFilename);
          })
          .catch(error =>
            console.error(
              'Failed to download Agsn report, error:' +
              buildErrorMessage(error),
            ),
          );
      }
    } catch (error) {
      console.error(
        'Failed to download lineout report, error:' + buildErrorMessage(error),
      );
    }
  };

  const [carryForwardAgSNDetails, setCarryForwardAgSNDetails] = useState({});
  const [carryForwardAgSNCount, setCarryForwardAgSNCount] = useState({});

  const [isCarryForwardModalOpen, setIsCarryForwardModalOpen] = useState(false);
  const openCarryForwardModal = () => setIsCarryForwardModalOpen(true);
  const closeCarryForwardModal = () => setIsCarryForwardModalOpen(false);

  const handleCarryForwardAgSN = (selectedRows = []) => {
    const allPlannedAgsns = rowsData.data.filter(
      agsn => agsn.status === AGGREGATE_STATUS.ASN_GENERATED,
    );
    if (allPlannedAgsns.length === 0) return;

    const selectedPlannedAgsns = (selectedRows || []).filter(
      agsn => agsn.status === AGGREGATE_STATUS.ASN_GENERATED,
    );

    if (!selectedRows || selectedRows.length === 0 || selectedPlannedAgsns.length === 0) {
      return showError({
        contextText: 'Please select a planned AgSN row for carry forward',
      });
    }

    setIsButtonEnable(false);

    let targetAgsn = allPlannedAgsns[0];
    let count = allPlannedAgsns.length;

    const selectedIndex = allPlannedAgsns.findIndex(
      agsn => agsn.agsnId === selectedPlannedAgsns[0].agsnId || agsn.id === selectedPlannedAgsns[0].id,
    );
    if (selectedIndex !== -1) {
      targetAgsn = allPlannedAgsns[selectedIndex];
      count = allPlannedAgsns.length - selectedIndex;
    } else {
      targetAgsn = selectedPlannedAgsns[0];
    }

    setCarryForwardAgSNDetails(targetAgsn);
    setCarryForwardAgSNCount(count);
    openCarryForwardModal();
  };

  const carryForwardAgSN = async data => {
    try {
      setIsButtonEnable(false);
      showLoading();
      await API.patch(
        API_RESOURCE_URLS.agsnCarryForward(plant.value, aggregateLine.value),
        {
          carryForwardFromAsnId: data.agsnId,
        },
      );
      closeCarryForwardModal();
      closePopUp();
      setIsButtonEnable(true);
      showSuccess({
        contextText: `AgSN carry forward success`,
      });
      loadAgsnsForADate(plant.value, aggregateLine.value, selectedDate);
    } catch (error) {
      console.error(buildErrorMessage(error));
      showError({
        contextText: `Failed to Carry Forward AgSN`,
        error: error,
      });
    }
  };
  return (
    <>
      <div className={styles.backButton}>
        <BackButton
          basePath={aggregate}
          action="Line Up"
          handleClick={redirectToApplicationLandingPage}
        />
      </div>
      <DropToolBar
        activeDate={selectedDate}
        dates={agsnDates}
        handleDateSelect={(date) => {
          setSelectedDate(date);
          chkControlToDisplay.current = true;
          setEnableRDFButton(true);
        }}
        lastRefreshedDate={lastRefreshedDate}
        contextualButtonProps={{
          text: 'PREVIOUS',
          label: 'Prev',
          handleClick: () => {
            setSelectedDate(moment().subtract(1, 'days'));
            setEnableRDFButton(false);
            chkControlToDisplay.current = false;
          },
        }}
        restrictNavigationDuringEditing
        hasActiveEdits={hasActiveEdits}
        showAggregateLines
        isPrintingEnabled={isPrintingEnabled}
        setIsPrintingEnabled={setIsPrintingEnabled}
        showPrintingToggle={
          plant.label === PANTNAGAR_PLANT_NAME && aggregate === AGGREGATES.BIW
        }
      />
      <BulkOptionsToolbar
        line={aggregateLine}
        activeAsnDate={selectedDate}
        selectedAsns={selectedAsns}
        asns={rowsData.data}
        reloadData={reloadData}
        isLoading={rowsData.loading}
        handleClose={closeAssignShiftForm}
        assignShift={assignShift}
        bulkAssignShift={bulkAssignShift}
        isAssignShiftFormOpen={isAssignShiftFormOpen}
        classNames={{ assignShiftFormPaper: styles.assignShiftFormPaper }}
        title="AgSN"
        shifts={shiftAvailability}
        isAssignShiftFormDataLoading={isLoading}
      />
      <div className={styles.container}>
        <div className={styles.tableView} style={{ height: '100%' }}>
          <AltMatWarningDailog
            open={isWarningOpen}
            handleClose={() => setIsWarningOpen(false)}
            message={
              <>
                Found some alternate part for Agsn.
                <br />
                Are you sure you want to mark ready for drop ?
              </>
            }
            generateAgsn={() => {
              callOnAltMatConfirmation(selectedRowsReadyForDrop);
            }}
          />

          <Table
            columns={[...baseDefaultColumns, ...optionalColumns]}
            defaultColumns={[...baseDefaultColumns]}
            rowHeight={ROW_HEIGHT}
            rows={rowsData.data}
            setHasActiveEdits={setHasActiveEdits}
            setAsnCount={setCount}
            isDataLoading={rowsData.loading}
            displayHash
            primaryAction={{
              name: 'READY FOR DROP',
              actionFn: readyfordropRows,
              authOperation: getAggregateAuthOperation(USER_OPERATIONS.AGGREGATE_READY_FOR_DROP, plant),
              shouldEnable: selectedRows => {
                return (
                  enableRDFButton &&
                  selectedRows.length &&
                  selectedRows.every(
                    row => row.status === AGGREGATE_STATUS.ASN_GENERATED,
                  ) &&
                  checkForPendingAgsns(selectedRows) &&
                  !hasPendingBacklogAsns
                );
              },
            }}
            secondaryActions={[
              {
                name: 'SWAP',
                actionFn: selectedRows => openAgsnSwapModal(selectedRows),
                authOperation: getAggregateAuthOperation(USER_OPERATIONS.AGGREGATE_SWAP, plant),
                shouldEnable: selectedRows => selectedRows.length === 1,
              },
              {
                name: 'PULLBACK',
                actionFn: selectedRows => openPullBackModal(selectedRows),
                authOperation: getAggregateAuthOperation(USER_OPERATIONS.AGGREGATE_PULLBACK, plant),
                shouldEnable: selectedRows => {
                  return (
                    selectedRows.length &&
                    rowsData?.data[0]?.status ===
                    AGGREGATE_STATUS.ASN_GENERATED &&
                    selectedRows.every(
                      row => row.status === AGGREGATE_STATUS.ASN_GENERATED,
                    ) &&
                    checkForPendingAgsnsOrAsn(
                      rowsData.data,
                      selectedRows,
                      selectedDate,
                      AGGREGATE_STATUS.ASN_GENERATED,
                    )
                  );
                },
              },
              {
                name: 'LINE-OUT',
                actionFn: selectedRows => openModal(selectedRows),
                backgroundColor: '#F17C7C',
                authOperation: RESOURCE_OPERATION,
                shouldEnable: selectedRows =>
                  selectedRows.length &&
                  selectedRows.every(
                    row => row.status === AGGREGATE_STATUS.ASN_GENERATED,
                  ),
              },

              {
                name: 'ASSIGN SHIFT',
                actionFn: selectedRows => openAssignShiftForm(selectedRows),
                authOperation: getAggregateAuthOperation(USER_OPERATIONS.ASSIGN_SHIFT_TO_MATERIAL, plant),
                shouldEnable: () => rowsData.data.length || selectedDate,
              },
              {
                name: 'DOWNLOAD CSV',
                getFilteredData: true,
                authOperation: getAggregateAuthOperation(USER_OPERATIONS.GET_CHASSIS_PLAN_ASN, plant),
                shouldEnable: () => rowsData.data.length > 0,
                actionFn: filteredData =>
                  generateAndDownloadLineoutCsvReport(filteredData),
              },
              {
                name: 'CARRY FORWARD',
                authOperation: getAggregateAuthOperation(USER_OPERATIONS.AGGREGATE_CARRYFORWARD, plant),
                shouldEnable: selectedRows => {
                  const allPlannedAgSNs = rowsData.data.filter(
                    agsn => agsn.status === AGGREGATE_STATUS.ASN_GENERATED,
                  );
                  if (allPlannedAgSNs.length > 0) return true;
                },
                backgroundColor: plant.label === JLR_PLANT && '#FFFFFF',
                textColor: plant.label === JLR_PLANT && '#6AA98F',
                actionFn: selectedRows => handleCarryForwardAgSN(selectedRows),
              },
              {
                name: "LINE TRANSFER",
                actionFn: (selectedRows) => openLineTransferModal(selectedRows),
                backgroundColor: "#608fc9",
                authOperation: getAggregateAuthOperation(USER_OPERATIONS.AGGREGATE_READY_FOR_DROP, plant),
                shouldEnable: () => rowsData.data.length,
              },
              ...(plant.label === PANTNAGAR_PLANT_NAME &&
                aggregate === AGGREGATES.BIW
                ? [
                  {
                    name: "Reprint Barcode",
                    actionFn: reprintRows,
                    authOperation: RESOURCE_OPERATION,
                    shouldEnable: (selectedRows) =>
                      isPrintingEnabled &&
                      selectedRows.length > 0 &&
                      selectedRows.every(
                        (row) =>
                          row.status === AGGREGATE_STATUS.DROPPED ||
                          row.status === AGGREGATE_STATUS.READY_FOR_DROP
                      ),
                  },
                ]
                : []),
            ]}
          />
        </div>
      </div>
      {isAgsnSwapModalOpen ? (
        <AgsnSwapModal
          open={true}
          setAgsnSwapCount={setAgsnSwapCount}
          setIsAgsnSwapModalOpen={setIsAgsnSwapModalOpen}
          selectedAgsn={selectedAgsnsForSwap}
          loadLinedOutAgsnOfSelectedPlantAndLineForDate={
            loadLinedOutAgsnOfSelectedPlantAndLineForDate
          }
          loadAgsnsForADate={loadAgsnsForADate}
          selectedDate={selectedDate}
        />
      ) : null}
      {isLineOutModalOpen ? (
        <CommentFormModal
          open={isLineOutModalOpen}
          handleClose={closeModal}
          title="Line-Out"
          rowsData={selectedRows}
          reasons={aggregateReasons}
          agencies={aggregateAgencies}
          lineBackgroundColor="#82C1A7"
          handleSubmit={(rows, reason, agency, comment) => {
            lineoutRows(rows, reason, agency, comment);
          }}
        />
      ) : null}
      {isPullbackModalOpen ? (
        <CommentFormModal
          open={isPullbackModalOpen}
          handleClose={closePullBackModal}
          title="Pullback"
          rowsData={selectedRows}
          reasons={aggregateReasons}
          agencies={aggregateAgencies}
          lineBackgroundColor="#82C1A7"
          handleSubmit={(rows, reason, agency, comment) => {
            pullBackAgsn(rows, reason, agency, comment);
          }}
        />
      ) : null}
      {isCarryForwardModalOpen ? (
        <CarryForwardModal
          open={isCarryForwardModalOpen}
          asnCarryForwardCount={carryForwardAgSNCount}
          handleClose={closeCarryForwardModal}
          rowsData={carryForwardAgSNDetails}
          handleSubmit={carryForwardAgSN}
        />
      ) : null}
      {isLineTransferModalOpen && transferLines ? (
        <LineTransferModal
          open={isLineTransferModalOpen}
          handleClose={closeLineTransferModal}
          title="Line-Transfer"
          lineBackgroundColor="#82C1A7"
          lines={transferLines.map((line) => line.lineName)}
          handleSubmit={handleLineSelectionForLineTransfer}
        />
      ) : null}
      {isLineTransferAsnDisplayOpen ? (
        <DayWiseFinishedGoodsLineTransferDisplay
          open={isLineTransferAsnDisplayOpen}
          handleClose={closeLinetransferAnsDisplay}
          updateRows={reloadData}
          startDate={selectedDate}
          endDate={selectedDate}
          plant={plant.value}
          line={aggregateLine.value}
          toline={lineSelectedForTransfer.line}
          lineName={lineSelectedForTransfer.lineName}
          type="AGSN"
        />
      ) : null}
      <ReprintWarningDialog
        open={isReprintConfirmationOpen}
        onCancel={handleCancelReprint}
        onConfirm={handleConfirmReprint}
      />
    </>
  );
};

DayWiseAgsn.propTypes = {
  setHasActiveEdits: PropTypes.func.isRequired,
  hasActiveEdits: PropTypes.bool.isRequired,
  aggregate: PropTypes.string.isRequired,
  lastRefreshedDate: PropTypes.objectOf(moment),
  alternatePartResponse: PropTypes.array,
  rowsData: PropTypes.arrayOf(
    PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      data: PropTypes.array.isRequired,
      filteredData: PropTypes.array.isRequired,
    }),
  ),
  setHasDayWiseAciveEdit: PropTypes.func.isRequired,
  loadAgsnsForADate: PropTypes.func.isRequired,
  selectedDate: PropTypes.objectOf(moment),
  setSelectedDate: PropTypes.func.isRequired,
  setAgsnCount: PropTypes.func.isRequired,
  hasPendingBacklogAsns: PropTypes.bool,
  loadLinedOutAgsnOfSelectedPlantAndLineForDate: PropTypes.func.isRequired,
  agsnDates: PropTypes.array.isRequired,
};

export default withAllowedOperationsProvider(
  DayWiseAgsn,
  true,
  RESOURCE_TYPE.MATERIAL,
);
